import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MeProvider } from '@/lib/MeContext';
import { ProjectProvider } from '@/lib/ProjectContext';
import { AppShell } from '@/components/shell/AppShell';
import { Login } from '@/routes/Login';
import { SetPassword } from '@/routes/SetPassword';
import { RequireAuth } from '@/routes/RequireAuth';
import { RequireRole } from '@/routes/RequireRole';
import { AdminUsers } from '@/routes/AdminUsers';
import { Projects } from '@/routes/Projects';
import { ProjectNew } from '@/routes/ProjectNew';
import { ProjectEdit } from '@/routes/ProjectEdit';
import { Clients } from '@/routes/Clients';
import { ClientNew } from '@/routes/ClientNew';
import { ClientEdit } from '@/routes/ClientEdit';
import { Sellers } from '@/routes/Sellers';
import { SellerNew } from '@/routes/SellerNew';
import { SellerEdit } from '@/routes/SellerEdit';
import { Contracts } from '@/routes/Contracts';
import { ContractNew } from '@/routes/ContractNew';
import { ContractDetail } from '@/routes/ContractDetail';
import { Dashboard } from '@/routes/Dashboard';
import { AuditLog } from '@/routes/AuditLog';

export function App() {
  return (
    <BrowserRouter>
      <MeProvider>
        <ProjectProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route element={<RequireAuth />}>
              <Route element={<AppShell />}>
                <Route index element={<Dashboard />} />
                <Route
                  path="proyectos"
                  element={
                    <RequireRole allow={['admin']}>
                      <Projects />
                    </RequireRole>
                  }
                />
                <Route
                  path="proyectos/nuevo"
                  element={
                    <RequireRole allow={['admin']}>
                      <ProjectNew />
                    </RequireRole>
                  }
                />
                <Route
                  path="proyectos/:id"
                  element={
                    <RequireRole allow={['admin']}>
                      <ProjectEdit />
                    </RequireRole>
                  }
                />
                <Route path="clientes" element={<Clients />} />
                <Route path="clientes/nuevo" element={<ClientNew />} />
                <Route path="clientes/:id" element={<ClientEdit />} />
                <Route
                  path="vendedores"
                  element={
                    <RequireRole allow={['admin']}>
                      <Sellers />
                    </RequireRole>
                  }
                />
                <Route
                  path="vendedores/nuevo"
                  element={
                    <RequireRole allow={['admin']}>
                      <SellerNew />
                    </RequireRole>
                  }
                />
                <Route
                  path="vendedores/:id"
                  element={
                    <RequireRole allow={['admin']}>
                      <SellerEdit />
                    </RequireRole>
                  }
                />
                <Route path="dashboard" element={<Navigate to="/" replace />} />
                <Route path="contratos" element={<Contracts />} />
                <Route path="contratos/nuevo" element={<ContractNew />} />
                <Route path="contratos/:id" element={<ContractDetail />} />
                <Route
                  path="auditoria"
                  element={
                    <RequireRole allow={['admin']}>
                      <AuditLog />
                    </RequireRole>
                  }
                />
                <Route
                  path="admin/users"
                  element={
                    <RequireRole allow={['admin']}>
                      <AdminUsers />
                    </RequireRole>
                  }
                />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ProjectProvider>
      </MeProvider>
    </BrowserRouter>
  );
}
